// utils/apiUtils.js
export const getApiBaseUrl = () => {
  if (typeof window === "undefined") return "http://localhost:8000/v1";
  
  const hostname = window.location.hostname;
  // Browser stack
  if (hostname.includes("bs-local")) {
    return "http://bs-local.com:8000/v1"
  }
  if (hostname.includes(".")) {
    // if hostname is an ip address, return the ip address with port 8000
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
      console.log("Hostname is an IP address, using http");
      return `http://${hostname}:8000/v1`;
    }
    if (hostname.includes("app")) {
      return `https://${hostname.replace("app", "api")}/v1`;
    }
    return `https://api.${hostname}/v1`;
  }
  return "http://localhost:8000/v1";
};